import { useAppDispatch } from 'shared/hooks';
import { useDeviceType } from '../context';
import { useCallback } from 'react';
import { getOffers } from 'shared/thunks/offers';

export const useGetOffersByDeviceType = () => {
  const dispatch = useAppDispatch();
  const deviceType = useDeviceType();

  return useCallback(() => {
    dispatch(getOffers(deviceType));
  }, [deviceType, dispatch]);
};
